<template>
  <ui-ask-danger ref="ask"/>
  <div class="lg:col-span-9 py-6 px-4 sm:p-6 lg:pb-8">
    <ui-form @submit.prevent.stop="save" :errors="errors">
      <div>
        <div>
          <h2 class="text-lg leading-6 font-medium text-gray-900">Изменить пароль</h2>
          <p class="mt-1 text-sm text-gray-500">
            Для смена пароля введите новый пароль и подтвердите его, пароль должен не менее четырех символов
          </p>
        </div>

        <div class="grid grid-cols-1 sm:grid-cols-6">
          <ui-form-item class="mt-4 sm:col-span-4" label="Пароль" required name="password">
            <ui-form-password v-model="form.password"/>
          </ui-form-item>
          <ui-form-item class="mt-4 sm:col-span-4" label="Повторите пароль" required>
            <ui-form-password v-model="form.password_confirm"/>
          </ui-form-item>
        </div>
      </div>

      <div class="mt-6">
        <ui-button type="submit">Изменить пароль</ui-button>
      </div>

    </ui-form>
  </div>
</template>

<script>

import UiButton from "@/components/ui/button/UiButton";
import UiFormItem from "@/components/ui/form/UiFormItem";
import UiForm from "@/components/ui/form/UiForm";
import UiFormPassword from "@/components/ui/form/UiFormPassword";
import UiAskDanger from "@/components/ui/ask/UiAskDanger";

export default {
  name: "UserPassword",
  components: {UiAskDanger, UiFormPassword, UiForm, UiFormItem, UiButton},
  props: {
    user_id: {}
  },
  data() {
    return {
      errors: {},
      regions: [],
      form: {
        password: '',
        password_confirm: '',
      }
    }

  },
  methods: {
    async save() {
      if (this.form.password.length > 0) {
        this.$refs.ask.show({title: 'Изменить текущий пароль?'}).then(() => {

        })
      }
    },

  },

}
</script>
